// extracted by css-extract-rspack-plugin
export default {"content":"content-uqSQyN","info":"info-J0nB0u","responseItem":"responseItem-eQ65IY","arrow":"arrow-DEh7iX"};